import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("tnp-lang");
    if (saved === "fr" || saved === "en") return saved;
    const nav = (navigator.language || "fr").toLowerCase();
    return nav.startsWith("en") ? "en" : "fr";
  });

  useEffect(() => {
    localStorage.setItem("tnp-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const value = key.split(".").reduce((o, k) => (o ? o[k] : undefined), translations[lang]);
    return value !== undefined ? value : key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
